import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";

export default function LinkEditModal({ title, onCancel, onSave, saveDisabled = false, children }) {
  const { t } = useTranslation();

  return (
    <div className="tw-fixed tw-inset-0 tw-z-[9999] tw-flex tw-items-center tw-justify-center tw-bg-[#190033]/85 tw-backdrop-blur-md tw-p-4">
      <div className="tw-relative tw-w-full tw-max-w-[480px] tw-bg-[#1F0439] tw-border tw-border-[#FFB0CF]/10 tw-shadow-[0_0_25px_rgba(255,67,167,0.25)] tw-rounded-xl tw-p-8 tw-flex tw-flex-col tw-gap-6 tw-overflow-hidden">
        <div className="tw-absolute tw-w-[384px] tw-h-[384px] tw-rounded-full tw-bg-[#FF43A7]/10 tw-blur-[60px] -tw-left-24 -tw-top-24 tw-pointer-events-none" />
        <div className="tw-absolute tw-w-[384px] tw-h-[384px] tw-rounded-full tw-bg-[#651CA4]/10 tw-blur-[60px] -tw-right-24 -tw-bottom-24 tw-pointer-events-none" />

        <div className="tw-relative tw-z-10 tw-flex tw-flex-col tw-gap-6">
          <h2 className="tw-text-[#F0DBFF] tw-text-[20px] tw-leading-[25px] tw-font-bold tw-m-0 tw-tracking-tight">
            {title}
          </h2>

          {children}

          <div className="tw-flex tw-justify-end tw-items-center tw-gap-4 tw-mt-2">
            <button
              onClick={onCancel}
              className="tw-flex tw-items-center tw-gap-2 tw-px-6 tw-h-[44px] tw-bg-transparent tw-border tw-border-[#AA8894]/30 tw-rounded-lg tw-text-[#F0DBFF] tw-text-[12px] tw-font-bold tw-tracking-[1.2px] tw-uppercase hover:tw-bg-white/5 tw-transition-colors tw-cursor-pointer"
            >
              <FontAwesomeIcon icon={faXmark} /> {t("Cancel")}
            </button>
            <button
              onClick={onSave}
              disabled={saveDisabled}
              className="tw-flex tw-items-center tw-gap-2 tw-px-8 tw-h-[44px] tw-bg-[#FF43A7] tw-border-none tw-rounded-lg tw-text-[#570033] tw-text-[12px] tw-font-extrabold tw-tracking-[1.2px] tw-uppercase hover:tw-bg-[#ff5cac] tw-transition-colors tw-shadow-[0_0_15px_rgba(255,67,167,0.4)] tw-cursor-pointer disabled:tw-opacity-40 disabled:tw-cursor-not-allowed disabled:hover:tw-bg-[#FF43A7]"
            >
              <FontAwesomeIcon icon={faCheck} /> {t("Save")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
